import tracking from 'tracking';

const defaults = {
  visibleItems: 3,
  selector: '.grid__item',
  transitionClass: 'js-batch-list-toggle-item',
  toggleClass: 'is-hidden',
  buttonWrapClass: 'batch-list__button-wrap',
  buttonClass: 'batch-list__button',
  buttonText: 'Alles anzeigen'
};

class BatchList {

  constructor (element, settings) {
    this.batchList = element;
    this.options = Object.assign({}, defaults, settings);

    this.allItems = element.querySelectorAll(this.options.selector);
    this.hiddenItems = [...this.allItems].slice(
      parseInt(this.options.visibleItems),
      this.allItems.length
    );

    this.buttonListener = this.clickEvent.bind(this);
    this.button = document.createElement('button');
    this.buttonWrap = document.createElement('div');
  }

  hideBatchItems () {
    this.hiddenItems.map(item => {
      item.classList.add(this.options.transitionClass);
      this.hideElement(item);
    });
  }

  showElement (element) {
    element.setAttribute('aria-hidden', false);
    element.classList.remove(this.options.toggleClass);
  }

  hideElement (element) {
    element.setAttribute('aria-hidden', true);
    element.classList.add(this.options.toggleClass);
  }

  clickEvent () {
    this.hiddenItems.map(item => this.showElement(item));
    this.removeButton();
    tracking.trackingEvent('showMoreTeasers', tracking.getTrackingParams(this.batchList));
  }

  removeButton () {
    this.batchList.removeChild(this.buttonWrap);
  }

  insertButton () {
    const { buttonWrapClass, buttonClass, buttonText } = this.options;

    this.button.addEventListener('click', this.buttonListener, false);

    this.buttonWrap.className = buttonWrapClass;
    this.batchList.appendChild(this.buttonWrap);

    this.button.type = 'button';
    this.button.className = buttonClass;
    this.button.innerHTML = buttonText;
    this.buttonWrap.appendChild(this.button);
  }

  init () {
    this.hideBatchItems();
    this.insertButton();
  }

  destroy () {
    this.hiddenItems.map(item => {
      item.classList.remove(this.options.transitionClass);
      item.classList.remove(this.options.toggleClass);
      item.removeAttribute('aria-hidden');
    });
    this.removeButton();
  }

}

export default BatchList;
